import { httpGetResponse, httpPost, httpPut } from '../../../api/httpClient';
import { CatalogReference, CatalogReferenceKind, AdminListResult } from '../../../api/types';

const referencePath = (kind: CatalogReferenceKind): string => `/v1/catalog-reference/${kind}`;
export const catalogReferenceApi = {
  async list(kind: CatalogReferenceKind, search = '', page = 1, id?: number): Promise<AdminListResult<CatalogReference>> {
    const params: Record<string, string> = { search, page: String(page), per_page: '20' };
    if (id !== undefined) params.id = String(id);
    const path = referencePath(kind);
    const response = await httpGetResponse<CatalogReference[]>(path, params);
    return { items: response.data, meta: response.meta };
  },
  create(kind: CatalogReferenceKind, name: string): Promise<CatalogReference> {
    const path = referencePath(kind);
    return httpPost<CatalogReference>(path, { name });
  },
  update(kind: CatalogReferenceKind, id: number, name: string): Promise<CatalogReference> {
    const path = `${referencePath(kind)}/${id}`;
    return httpPut<CatalogReference>(path, { name });
  },
};
export function referenceId(reference: CatalogReference): number { return reference.brand_id ?? reference.manufacturer_id ?? 0; }
export function referenceName(reference: CatalogReference): string { return reference.brand_name ?? reference.manufacturer_name ?? 'Без названия'; }
